import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { AnnualDiff } from './components/AnnualDiff/AnnualDiff';
import { WinnersInKr } from './components/Winners/WinnersInKr';
import { WinnersInPercent } from './components/Winners/WinnersInPercent';
import { LoosersInKr } from './components/Loosers/LoosersInKr';
import { LoosersInPercent } from './components/Loosers/LoosersInPercent';
import { ManualCalculation } from './components/ManualCalculation/ManualCalculation';

import './custom.scss'

export default class Avgiftsberegning extends Component {
    static displayName = Avgiftsberegning.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={AnnualDiff} />
                <Route path='/AnnualDiff' component={AnnualDiff} />
                <Route path='/WinnersInKr' component={WinnersInKr} />
                <Route path='/WinnersInPercent' component={WinnersInPercent} />
                <Route path='/LoosersInKr' component={LoosersInKr} />
                <Route path='/LoosersInPercent' component={LoosersInPercent} />
                <Route path='/ManualCalculation' component={ManualCalculation} />
            </Layout>
        );
    }
}
